const types = {
	THRESHOLD: 2,
};

const thresholdDirections = {
	down: {
		value: 1,
		resourceKey: 'thresholdDirectionDown',
	},
	up: {
		value: 2,
		resourceKey: 'thresholdDirectionUp',
	},
};

const priceTypes = {
	bid: {
		value: 1,
		resourceKey: 'thresholdPriceTypeBid',
	},
	ask: {
		value: 2,
		resourceKey: 'thresholdPriceTypeAsk',
	},
};


export {
	types,
	thresholdDirections,
	priceTypes,
};
